window.OAAlgoliaApi = {
  _client: null,

  /**
   * @param {string} appId
   * @param {string} apiKey
   * @returns {object}
   */
  getClient: function (appId, apiKey) {
    if (!this._client) {
      this._client = window["algoliasearch/lite"].liteClient(appId, apiKey);
      var ids = window.oaMarketLocationIds;
      if (Array.isArray(ids) && ids.length) this._scopeToMarket(this._client, ids);
    }
    return this._client;
  },

  /**
   * Stock in the shopper's market from locations_inventory: true/false, or null when the record
   * can't say (no key for any market location, or Shopify sells it without stock).
   * @param {object} hit
   * @param {string[]} ids - window.oaMarketLocationIds
   * @returns {boolean|null}
   */
  marketStock: function (hit, ids) {
    var byLocation = hit && hit.locations_inventory;
    if (!byLocation) return null;
    // "Continue selling" and untracked variants are available with no quantity.
    if (hit.inventory_policy === 'continue' || (hit.inventory_available && !(hit.inventory_quantity > 0))) return null;
    var known = false;
    for (var i = 0; i < ids.length; i++) {
      var qty = byLocation[ids[i]];
      if (typeof qty === 'number') {
        known = true;
        if (qty > 0) return true;
      }
    }
    return known ? false : null;
  },

  /**
   * Sponsorship: rewrites shop-level inventory_available to market stock for every consumer.
   * A distinct hit is one variant, so a sold-out one is re-checked against its siblings.
   */
  _scopeToMarket: function (client, ids) {
    var api = this;
    var search = client.search;
    var inMarket = ids.map(function (id) { return 'locations_inventory.' + id + ' > 0'; }).join(' OR ');

    function scopeHits(response) {
      (response && response.results || []).forEach(function (result) {
        (result.hits || []).forEach(function (hit) {
          var stock = api.marketStock(hit, ids);
          if (stock !== null) hit.inventory_available = stock;
        });
      });
      return response;
    }

    client.search = function () {
      return search.apply(client, arguments).then(function (response) {
        var unsure = {};
        (response && response.results || []).forEach(function (result) {
          (result.hits || []).forEach(function (hit) {
            var stock = api.marketStock(hit, ids);
            if (stock === false && hit.inventory_available && hit.id && result.index) {
              (unsure[result.index] = unsure[result.index] || []).push(hit);
            } else if (stock !== null) {
              hit.inventory_available = stock;
            }
          });
        });
        var indexes = Object.keys(unsure);
        if (!indexes.length) return response;

        return search.call(client, {
          requests: indexes.map(function (index) {
            return {
              indexName: index,
              query: '',
              filters: '(' + unsure[index].map(function (hit) { return 'id=' + hit.id; }).join(' OR ') + ') AND (' + inMarket + ')',
              attributesToRetrieve: ['id'],
              hitsPerPage: 1000,
              analytics: false
            };
          })
        }).then(function (check) {
          indexes.forEach(function (index, i) {
            var found = {};
            check.results[i].hits.forEach(function (hit) { found[hit.id] = true; });
            unsure[index].forEach(function (hit) { hit.inventory_available = !!found[hit.id]; });
          });
          return response;
        }, function () {
          // Check failed: keep shop-level stock rather than call buyable products sold out.
          return response;
        });
      });
    };

    // Recommendations are the recommended variants themselves; no sibling check.
    var getRecommendations = client.getRecommendations;
    client.getRecommendations = function () {
      return getRecommendations.apply(client, arguments).then(scopeHits);
    };
  },

  filters: {
    /**
     * @param {string} facet
     * @param {string} value
     * @returns {string}
     */
    facetFilter: function (facet, value) {
      return `${facet}:${value}`;
    },

    /**
     * @param {string} facet
     * @param {boolean|string} value
     * @returns {string}
     */
    booleanFilter: function (facet, value) {
      return `${facet}:${value}`;
    },

    /**
     * @param {string} facet
     * @param {'<' | '<=' | '=' | '!=' | '>=' | '>'} operator
     * @param {number|string} value
     * @returns {string}
     */
    numericComparison: function (facet, operator, value) {
      return `${facet} ${operator} ${value}`;
    },

    /**
     * @param {string} facet
     * @param {number|string} low
     * @param {number|string} high
     * @returns {string}
     */
    numericRange: function (facet, low, high) {
      return `${facet}:${low} TO ${high}`;
    },

    /**
     * @param {string} value
     * @returns {string}
     */
    tagFilter: function (value) {
      return value;
    },

    /**
     * @param {string} value
     * @returns {string}
     */
    quote: function (value) {
      const needsQuotes = value.includes(' ')
        || value.includes('"')
        || value.includes('\'')
        || 'AND' === value
        || 'OR' === value
        || 'NOT' === value;
      if (!needsQuotes) {
        return value;
      }
      // TODO: JSON.stringify('UnifiedMove™ High Waisted Shorts 6"') produces "UnifiedMove™ High Waisted Shorts 6\"" — it escapes the double quote with a backslash. Algolia's docs don't mention backslash escaping in filter values. The previous approach (pick the other quote type) was safer. Worth testing whether Algolia accepts \" in filters.
      return JSON.stringify(value);
    },

    AND: ' AND ',

    /**
     * @param {Array} filters
     * @returns {string}
     */
    and: function (filters) {
      return `${filters.join(' AND ')}`;
    },

    /**
     * @param {Array} filters
     * @returns {string}
     */
    or: function (filters) {
      return `${filters.join(' OR ')}`;
    },

    /**
     * @param {string} expression
     * @returns {string}
     */
    not: function (expression) {
      return `NOT ${expression}`;
    },

    /**
     * @param {string} expression
     * @returns {boolean}
     */
    startsWithNot: function (expression) {
      return expression.trimStart().startsWith('NOT ');
    },

    /**
     * @param {string} expressions
     * @returns {string}
     */
    group: function (expressions) {
      return `(${expressions})`;
    },
  },
};